// src/app/helpers/analytics.js

import { trackGA4Event } from './ga4'
import { getUserSegmentationData } from './ga4UserSegmentation'

// Global Redux store reference (set from app initialization)
let reduxStore = null

export const setReduxStore = (store) => {
  reduxStore = store
}

export const trackEvent = (dispatch, eventData = {}) => {
  const normalizedEvent = {
    ...eventData,
    route: eventData.route || window.location.pathname,
    timestamp: eventData.timestamp || Date.now(),
  }

  // Get user segmentation data from Redux if available
  let userProfile = null

  try {
    if (reduxStore) {
      const state = reduxStore.getState()
      if (state && state.myProfile) {
        userProfile = state.myProfile.userProfile || state.myProfile
      }
    }
  } catch (error) {
    console.error('Error getting Redux state:', error)
  }

  // Add user segmentation to event if available
  if (userProfile) {
    const segmentation = getUserSegmentationData(userProfile)
    normalizedEvent.userCampus = segmentation.campus
    normalizedEvent.userType = segmentation.userType
    normalizedEvent.userAffiliation = segmentation.affiliation
  } else {
    // Fallback to Unknown if no profile
    normalizedEvent.userCampus = 'Unknown'
    normalizedEvent.userType = 'Unknown'
    normalizedEvent.userAffiliation = 'Unknown'
  }

  // Fire GA4 tracking asynchronously without blocking
  trackGA4Event(normalizedEvent).catch(() => {
    // Silently fail GA4 tracking
  })
}
